import "./Pill.css";

export default function Pill({
  variant = "neutral",
  children,
  className,
  ...rest
}) {
  const cls = [
    "vs-pill",
    `vs-pill--${variant}`,
    className,
  ]
    .filter(Boolean)
    .join(" ");
  return (
    <span className={cls} {...rest}>
      {children}
    </span>
  );
}
